import {Search} from "react-feather";
import {get} from "global/slices/credits/thunks";
import {CreditCardOutlined} from "@mui/icons-material";
import {Header as HeaderComponent, Input, Row} from "components";
import {
  useAppDispatch,
  useAppSelector,
  useBreakpoints,
  useDebouncedSearch,
} from "hooks";

interface HeaderProps {}

export const Header: React.FC<HeaderProps> = () => {
  const dispatch = useAppDispatch();
  const {downXl, downMd} = useBreakpoints();
  const {pagination} = useAppSelector("credits");
  const {setQuery} = useDebouncedSearch({
    onDebounce: (ser) =>
      dispatch(get({...pagination, refresh: true, ser, pos: 0})),
    onEmptyQuery: () =>
      dispatch(get({...pagination, refresh: true, ser: "", pos: 0})),
  });

  return (
    <Row
      width="100%"
      gap={downMd ? 10 : 5}
      justifyContent="space-between"
      flexDirection={downXl ? "column" : "row"}
      alignItems={downXl ? "flex-start" : "center"}
    >
      <HeaderComponent icon={CreditCardOutlined} children="Créditos" />
      <Row gap={1} alignItems="center">
        <Input
          icon={Search}
          placeholder="Buscar créditos"
          containerStyle={{maxWidth: "350px", marginBottom: 0}}
          onChange={({target}) => {
            setQuery(target["value"]);
          }}
        />
      </Row>
    </Row>
  );
};
